export const handleCoverEmail = (clientEmail) => {
  if (clientEmail) {
    const emailSplited = clientEmail.split('@');
    const twoCharacterRegex = /^(.{2}).*(.{2}@.*)$/; // Show the 2 first and last characters before @
    const oneCharacterRegex = /^(.{1}).*(.{1}@.*)$/; // Show first and last characters before @
    const regex = emailSplited[0].length >= 5 ? twoCharacterRegex : oneCharacterRegex;
    const matches = clientEmail.match(regex);
    const coveredEmail = matches ? `${matches[1]}*****${matches[2]}` : '*****';
    return coveredEmail;
  }
  return '*****';
};
